<template>
  <footer class="footer">
    <div class="footer__wrapper" v-if="body">
      <div class="footer__wrapper__foot">
        <div class="footer__wrapper__foot__links">
          <div class="footer__wrapper__foot__brand">
          <a href="https://agaru.tv" class="footer__wrapper__foot__logo"><img src="/static/img/store-logo.svg" alt="" class="footer__wrapper__foot__logo"></a>
          <ul class="footer__wrapper__foot__sns">
            <li class="twitter"><a href="https://twitter.com/agarutv" target="_blank">
              <img class="footer__wrapper__foot__sns__img" width="32" height="32" alt="twitter" src="/static/img/ic-twitter-footer.svg">
              <span class="footer__wrapper__foot__sns__text"> 公式Twitter </span></a></li>
            <li class="facebook" ><a href="https://www.facebook.com/uranaitv.jp/" target="_blank">
              <img class="footer__wrapper__foot__sns__img" width="32" height="32" alt="facebook" src="/static/img/ic-facebook-footer.svg">
              <span class="footer__wrapper__foot__sns__text"> 公式facebook </span></a></li>
          </ul>
          </div>

        <div class="footer-links" >
          <div class="footer-links-list">
            <a href="https://agaru.tv/pre_faq/" class="footer__wrapper__link__button" rel="nofollow">よくある質問</a>
            <a href="https://agaru.tv/pre_inquiry/" class="footer__wrapper__link__button" rel="nofollow">お問い合わせ</a>
            <a href="https://agaru.tv/notifications/" class="footer__wrapper__link__button" rel="nofollow">お知らせ</a>
          </div>
          <div class="footer-links-list">
            <a href="https://agaru.tv/terms-of-service/" class="footer__wrapper__link__button" rel="nofollow">利用規約</a>
            <a href="https://agaru.tv/privacy/" class="footer__wrapper__link__button" rel="nofollow">プライバシーポリシー</a>
            <a href="https://agaru.tv/p-cookie/" class="footer__wrapper__link__button" rel="nofollow">Cookie利用について</a>
          </div>
          <div class="footer-links-list">
            <a href="https://agaru.tv/legal/" class="footer__wrapper__link__button" rel="nofollow">特定商取引に基づく表記</a>
            <a href="https://www.zappallas.com/" class="footer__wrapper__link__button" rel="nofollow" target="_blank" >運営会社</a>
          </div>
        </div>
        </div>

        <div class="footer__wrapper__link">
          <div class="footer__wrapper__bar"></div>
          <div class="footer__wrapper__link__button footer__wrapper__link__button__app">Apple および Apple ロゴは米国その他の国で登録された Apple Inc. の商標です。Apple Store は Apple Inc. のサービスマークです。Google Play および Google Play ロゴは、Google Inc.の商標です。
          </div>
        </div>
      </div>
    </div>
    <app-copyright></app-copyright>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';
import AppCopyright from './AppCopyright';

export default {
  name: 'appFooter',
  props: {
    body: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  components: {
    AppCopyright
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/variables/layout.scss";
@import "../../../sass/variables/colors.scss";
.footer {
  @media screen and (max-width: $breakpoint) {
    background-color: #fff;
  }
  &-links {
    display: block;
    margin-top: 32px;
    border-top: 1px #d8d8d8 solid;
    @media (min-width: $breakpoint) {
      padding: 8px 0;
      border-top: none;
      display: flex;
    }
    @media (min-width: 1020px) {
      margin-left: 64px;
      border-left: 1px #d8d8d8 solid;
      border-top: none;
      padding: 8px 0;
      display: flex;
    }
  }
  &-links-list {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    margin: 24px 0 0;
    @media (min-width: $breakpoint) {
      display: block;
      margin: 0;
      margin-left: 90px;
    }
  }

  &__wrapper {
    @media screen and (max-width: $breakpoint) {
      max-width: 580px;
      min-width: 320px;
      width: 100%;
    }
    @media screen and (max-width: 1020px ) {
      width: 100%;
    }
    width: 1020px;
    margin: 0 auto;
    &__account {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px;
      &__button {
        display: block;
        width: calc(50% - 8px);
        line-height: 30px;
        font-size: 12px;
        text-decoration: none;
        background: white;
        border: 1px solid #d8d8d8;
        border-radius: 4px;
      }
    }
    &__link {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      padding: 12px 0 0 0;
      &__sp {
        @media screen and (max-width: 1020px) {
          display: block;
        }
        display: none;
      }
      &__button {
        display: block;
        @media (max-width: 374px) {
          font-size: 11px;
        }
        @media screen and (max-width: $breakpoint) {
          padding: 0 12px 0 0;
        }
        padding: 0 12px 16px 0;
        font-size: 12px;
        text-decoration: none;
        color: #676767;
        &__app {
          font-size: 10px;
          padding: 0 12px 0px 12px;
        }
      }
    }
    &__bar {
      border-top: 1px solid #d8d8d8;
      padding: 0 0 24px 0 ;
      margin: 0 12px 0 12px;
      width: 100%;
    }
    &__foot {
      padding: 24px 0 32px 0 ;
      &__logo {
        display: table;
        margin: 0;
        img {
          display: block;
          width: 192px;
          height: 27px;
        }
      }
      &__links{
        display: flex;
        padding: 12px 12px 12px 12px;
        @media screen and (max-width: $breakpoint) {
          display: block;
        }
      }
      &__brand {
        @media screen and (max-width: $breakpoint) {
          display: flex;
          width: 100%;
        }
      }

      &__sns {
        @media screen and (max-width: $breakpoint) {
          margin: 0 0 0 auto;
        }
        margin: 24px 0 0 auto;
        padding: 0;
        display: flex;
        list-style: none;
        font-size: 12px;
        &__img {
          vertical-align: middle;
        }
        &__text {
          @media screen and (max-width: $breakpoint) {
            display: none;
          }
          display: inline;
          vertical-align: middle;
          padding: 8px 8px 8px 8px;
          color: $brand-1;
        }
        a {
          text-decoration: none;
          font-size: 12px;
          color: $text-main;
        }
      }

      &__link {
        display: flex;
        margin: 24px 0 0;
        padding: 0;
        list-style: none;
        &__button {
          display: block;
          line-height: 1;
          font-size: 12px;
          letter-spacing: 1px;
          text-decoration: none;
          &:first-child {
            border-right: 1px solid #d8d8d8;
          }
        }
      }
    }
  }
}
.facebook {
margin-left: 18px;
  @media screen and (max-width: $breakpoint) {
   margin-left: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppFooter.vue